import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { ProductLink } from "./product-link.model";

@Injectable({
	providedIn: "root",
})
export class ProductLinkSelector {
	get() {
		return (state: CommonState): ProductLink[] => state.productLink.content;
	}
}
